export enum routes {
  ABOUT = '/about',
  DISCLAIMER = '/disclaimer',
  INDEX_HTML = '/index.html',
  PRIVATE_ROOM = '/p/:roomId',
  PUBLIC_ROOM = '/:roomId',
  ROOT = '/',
  SETTINGS = '/settings',
}
